import { useRef, useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TruncatedTooltip = ({ text, maxWidth = 150 }) => {
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (textRef.current) {
            setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        }
    }, [text]);

    return (
        <OverlayTrigger placement="top" overlay={isTruncated ? <Tooltip>{text}</Tooltip> : <></>}>
            <span
                ref={textRef}
                style={{
                    maxWidth,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'inline-block'
                }}
            >
                {text}
            </span>
        </OverlayTrigger>
    );
};

export default TruncatedTooltip;
